const API_URL = process.env.VUE_APP_API_URL
const PREFERENCES_ENDPOINT = 'v1/onetrust/preferences'

export function eraseCookie (name) {
  // Delete root path cookies
  const domainName = window.location.hostname
  document.cookie = name + '=; Max-Age=-99999999; Path=/;Domain=' + domainName
  document.cookie = name + '=; Max-Age=-99999999; Path=/;'

  // Delete LSO incase LSO being used, cna be commented out.
  localStorage.removeItem(name)

  // Check for the current path of the page
  const pathArray = window.location.pathname.split('/')
  // Loop through path hierarchy and delete potential cookies at each path.
  for (var i = 0; i < pathArray.length; i++) {
    if (pathArray[i]) {
      // Build the path string from the Path Array e.g /site/login
      var currentPath = pathArray.slice(0, i + 1).join('/')
      document.cookie = name + '=; Max-Age=-99999999; Path=' + currentPath + ';Domain=' + domainName
      document.cookie = name + '=; Max-Age=-99999999; Path=' + currentPath + ';'
      // Maybe path has a trailing slash!
      document.cookie = name + '=; Max-Age=-99999999; Path=' + currentPath + '/;Domain=' + domainName
      document.cookie = name + '=; Max-Age=-99999999; Path=' + currentPath + '/;'
    }
  }
}

export const isGpcEnabled = () => {
  try {
    // Check OneTrust GPC configuration
    const oneTrustData = window.OneTrust?.GetDomainData?.()
    const isGpcEnabledInOneTrust = oneTrustData?.Groups?.some((group) =>
      group?.hosts?.some((host) => host?.IsGpcEnabled === true)
    )

    if (isGpcEnabledInOneTrust) {
      console.info('GPC is enabled in OneTrust.')
      return true // Short-circuit if OneTrust GPC is enabled
    }

    // Check browser's GPC signal
    if (navigator.globalPrivacyControl === true) {
      console.info('Browser GPC signal is enabled.')
      return true // Short-circuit if browser GPC is enabled
    }

    // If neither is enabled, return false
    console.info('No GPC signal is enabled.')
    return false
  } catch (error) {
    console.error('Error while checking GPC configuration:', error)
    return false // Fail-safe return
  }
}

export async function getPreferences (email) {
  const endpoint = `${API_URL}${PREFERENCES_ENDPOINT}/${email}`

  // Note: This endpoint will only return empty, "OPT_IN", or "OPT_OUT"
  // the full payload is handled in the BE API.
  try {
    const response = await fetch(endpoint)

    // Check if the response is successful
    if (response.ok) {
      const data = JSON.parse(await response.text())
      console.log('Fetched preferences:', data)
      return data
    } else {
      console.error(
        'Failed to fetch preferences:',
        response.status,
        await response.text()
      )
      return null
    }
  } catch (error) {
    console.error('Error fetching preferences:', error)
    return null
  }
}

export async function savePreferences (email) {
  const apiUrl = `${API_URL}${PREFERENCES_ENDPOINT}` // Laravel route
  const payload = {
    email: email
  }

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    console.info('Email: ' + email)
    if (response.ok) {
      const data = await response.json()
      window.savedPreferencesResponse = data

      if (data?.data?.receipt) {
        console.log('Preferences saved successfully:', data?.data)
      } else {
        console.error('Server responded without a receipt. Response:', data)
      }
    } else {
      console.error('Failed to save preferences:', response.status, await response.text())
    }
  } catch (error) {
    console.error('Error saving preferences:', error)
  }
}

export async function removeCookies () {
  const cookies = document.cookie.split('; ')
  const hostname = window.location.hostname
  const domains = [
    hostname,
    '.' + hostname.replace(/^www\./, '')
  ]
  const paths = ['/', window.location.pathname]
  console.log(cookies)

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i]
    const cookieParts = cookie.split('=')
    const name = cookieParts[0] ? cookieParts[0].replace(/^\s+|\s+$/g, '') : ''
    console.info(name)

    if (name.indexOf('Optanon') === 0 && name !== 'OptanonConsent') {
      for (let j = 0; j < domains.length; j++) {
        for (let k = 0; k < paths.length; k++) {
          document.cookie = name + '=; path=' + paths[k] + '; domain=' + domains[j] + '; expires=Thu, 01 Jan 1970 00:00:00 UTC'
        }
      }
      // Also try without domain, just in case
      for (let k = 0; k < paths.length; k++) {
        document.cookie = name + '=; path=' + paths[k] + '; expires=Thu, 01 Jan 1970 00:00:00 UTC'
      }
    }
  }
}

export async function disableCategories () {
  const currentConsent = document.cookie.split('; ').find(row => row.startsWith('OptanonConsent='))
  if (currentConsent) {
    const consentValue = decodeURIComponent(currentConsent.split('=')[1])
    const consentIdMatch = consentValue.match(/consentId=([^&]*)/)
    const consentId = consentIdMatch ? consentIdMatch[1] : ''

    document.cookie = 'OptanonConsent=' +
      'landingPath=NotLandingPage&' +
      'datestamp=' + encodeURIComponent(new Date().toString()) + '&' +
      'version=202503.1.0&' +
      'groups=1%3A1%2C2%3A0%2C4%3A0%2C9%3A0&' +
      'hosts=&' +
      'consentId=' + consentId + '&' +
      'interactionCount=1&' +
      'isAnonUser=0&' +
      'intType=6; path=/; Secure; SameSite=Lax'
  }
}

export function reInitOt () {
  if (typeof window.OneTrust?.Init === 'function') {
    window.OneTrust.Init()
  }

  if (typeof window.OptanonWrapper === 'function') {
    window.OptanonWrapper()
  }
}
